/**
 * Global video preloader for Slimmy
 * Starts preloading video blobs from the API as soon as the user logs in.
 * Feed.js reads from this cache for instant fullscreen playback.
 */

const videoCache = new Map(); // url -> blob URL
let preloadStarted = false;

export function getPreloadedVideoUrl(originalUrl) {
  return videoCache.get(originalUrl) || originalUrl;
}

export function isVideoPreloaded(url) {
  return videoCache.has(url);
}

export async function preloadVideoBlob(url) {
  if (!url || videoCache.has(url)) return;
  try {
    const resp = await fetch(url);
    if (!resp.ok) return;
    const blob = await resp.blob();
    const blobUrl = URL.createObjectURL(blob);
    videoCache.set(url, blobUrl);
  } catch {
    // silently fail
  }
}

export async function startGlobalVideoPreload(apiUrl) {
  if (preloadStarted) return;
  preloadStarted = true;

  try {
    const sessionToken = localStorage.getItem('session_token');
    if (!sessionToken) return;

    const res = await fetch(`${apiUrl}/api/posts?page=1&limit=20&filter=all`, {
      headers: { 'Authorization': `Bearer ${sessionToken}` },
      credentials: 'include'
    });
    if (!res.ok) return;
    const data = await res.json();
    const posts = data.posts || data || [];
    const videoPosts = posts.filter(p => p.video_url).slice(0, 10);

    // Preload videos sequentially to avoid overwhelming the connection
    for (const post of videoPosts) {
      await preloadVideoBlob(post.video_url);
    }
  } catch {
    // silently fail
  }
}

export function resetPreloadState() {
  preloadStarted = false;
}
